document.addEventListener('DOMContentLoaded', function() {
  // 1) Find the Add-to-Bag button & its form
  var button = document.querySelector('button.product-form__submit');
  if (!button) return console.warn('[DP] button not found');
  var form = button.closest('form');
  if (!form)   return console.warn('[DP] form not found');

  // 2) Inject the dynamic-price span (gap to icon is set here)
  var priceSpan = document.createElement('span');
  priceSpan.className = 'dynamic-price';
  priceSpan.style.marginLeft = '0.2em'; // reduced gap between icon and price
  priceSpan.style.fontSize = '0.9em';
  button.appendChild(priceSpan);

  // 3) Clone and style your header SVG inline, with tighter spacing
  var headerSvg = document.querySelector('#cart-icon-bubble svg');
  if (headerSvg) {
    console.log('[DP] cloning header SVG with tighter spacing');
    var svgClone = headerSvg.cloneNode(true);

    // Remove any existing fill/stroke attributes
    svgClone.removeAttribute('fill');
    svgClone.removeAttribute('stroke');

    // Force a larger size if you like (keep at 1.5em or adjust)
    svgClone.setAttribute('width',  '2em');
    svgClone.setAttribute('height', '2em');
    svgClone.style.display       = 'inline-block';
    svgClone.style.verticalAlign = 'middle';

      // For every shape inside, fill it white AND add a white stroke
  svgClone.querySelectorAll('*').forEach(function(el) {
    if (el.tagName.toLowerCase() === 'path' || el.tagName.toLowerCase() === 'circle' || el.tagName.toLowerCase() === 'rect') {
      el.setAttribute('fill',         '#fff');
      el.setAttribute('stroke',       '#fff');
      el.setAttribute('stroke-width', '0.04em');    // ← bump this up for thicker lines
      el.setAttribute('stroke-linejoin','round');  // smooth joins
      el.setAttribute('stroke-linecap', 'round');
    }
  });

    // Turn every shape inside it white
    svgClone.querySelectorAll('*').forEach(function(el) {
      if (el.hasAttribute('fill'))   el.setAttribute('fill',   '#fff');
      if (el.hasAttribute('stroke')) el.setAttribute('stroke', '#fff');
    });

    // Wrap it for spacing: only 0.1em on each side
    var iconWrapper = document.createElement('span');
    iconWrapper.className = 'btn-icon';
    iconWrapper.style.display       = 'inline-flex';
    iconWrapper.style.verticalAlign = 'middle';
    iconWrapper.style.margin        = '0 0.1em'; // tighter gap to text & price
    iconWrapper.appendChild(svgClone);

    // Insert it *before* the price span
    button.insertBefore(iconWrapper, priceSpan);
  } else {
    console.warn('[DP] header SVG not found at #cart-icon-bubble svg');
  }

  // 4) Pre-fetch product JSON
  var m = window.location.pathname.match(/\/products\/([^\/]+)/);
  if (!m) return console.warn('[DP] no product handle in URL');
  var productPromise = fetch('/products/' + m[1] + '.js')
    .then(function(res) { return res.json(); })
    .catch(function(err) {
      console.error('[DP] fetch error', err);
      return null;
    });

  // 5) Polling loop for dynamic price + 20% off at qty ≥3
  var lastVid, lastQty;
  function updatePrice() {
    Promise.resolve(productPromise).then(function(product) {
      if (!product) return;
      var vid = Number(form.querySelector('input[name="id"]').value);
      var qty = parseInt(new FormData(form).get('quantity'), 10) || 1;
      if (vid === lastVid && qty === lastQty) return;
      lastVid = vid; lastQty = qty;

      var variant = product.variants.find(function(v) { return v.id === vid; });
      if (!variant) {
        console.warn('[DP] variant not found for id', vid);
        return;
      }

      var subtotal = variant.price * qty;
      if (qty >= 3) subtotal *= 0.8; // apply 20% off when 3+

      // Format using Shopify.formatMoney with theme’s money_format
      var formatted;
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        var fmt = window.moneyFormat || window.Shopify.money_format || window.Shopify.moneyFormat || '${{amount}}';
        formatted = window.Shopify.formatMoney(subtotal, fmt);
      } else {
        // fallback: use Intl.NumberFormat based on shopCurrency
        try {
          var currency = window.shopCurrency || Shopify.currency.active || Shopify.currency.symbol;
          formatted = new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(subtotal/100);
        } catch (e) {
          formatted = (subtotal/100).toFixed(2);
        }
      }
      // General strip currency prefixes like 'US', 'CA', 'AUD' before symbol
      formatted = formatted.replace(/^[A-Z]{1,3}\s*/, '');

      priceSpan.textContent = ' ' + formatted;
      button.disabled = !variant.available;
      button.classList.toggle('btn--disabled', !variant.available);
    });
  }
  updatePrice();
  setInterval(updatePrice,300);
});
